// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"9825631430fd68f9664f","691":"8d7ff3c98ab0ff80734a"}[chunkId] + ".js";
};